/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 4000)

};

sections.extend('slideshow', slideshowAutoExtension);


$(document).ready(function(){
 
  $('.custom-thumbnails .custom-thumbnail img').on('click', function(){
    var pi = $('img.product__media-preview-image');
    pi.removeAttr('srcset'); 
    pi.attr('src', $(this).attr('src').replace('_100x.jpg', '.jpg'));
  });
  
  function initBgVideo() {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);    
    
  }
  
  $(window).on('resize', function(){
    resizeBgVideo();
  });
  
  initBgVideo();
  zoomOnProduct();
});


function onYouTubePlayerAPIReady() {
  //console.log('youtube api is ready');
  var sections = $('.bg-video-section');
  sections.each(function(){
    var section = $(this);
    var playerDiv = section.find('.video-section__player');
    var videoId = section.attr('data-video-id');
    //debugger;
    if (!videoId) return;
    
    var player = new YT.Player(playerDiv.attr('id'), {
      videoId: videoId,
      height: '1080',
      width: '1920',
      playerVars: {
        autoplay: 1,
        disablekb: 1,
        controls: 0,
        enablejsapi: 1,
        loop: 1,
        mute: 1,
        playlist: videoId
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  });
}

function resizeBgVideo() {
  var sections = $('.bg-video-section');
  sections.each(function(){
    var section = $(this);
    var sectionHeight = section.height();
    var sectionWidth = section.width();
    var ratio = sectionWidth / sectionHeight;
    var iframe = section.find('iframe');
    
    // if ratio less than 16:9
    if (ratio < (16 / 9)) {
      var marginTop = 60;
      var videoHeight = sectionHeight + marginTop;
      iframe.height(videoHeight);
      iframe.width(videoHeight * 16 / 9);
      iframe.css({ marginTop: -marginTop, transform: 'translate(-25%)' });            
    }
    // else
    else {
      var iframeHeight = sectionWidth * 9 / 16;
      iframe.width(sectionWidth);
      iframe.height(iframeHeight);
      var marginTop = (iframeHeight - sectionHeight) / 2;
      iframe.css({ marginTop: -marginTop, transform: 'translate(0)' });
    }
    
  });
}
  
function onPlayerReady(event) {
  
}

var firstBgPlay = true;
function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.PLAYING && firstBgPlay) {
    resizeBgVideo();
    var videoId = event.target.getVideoData().video_id;
    var section = $('.bg-video-section[data-video-id="' + videoId + '"]');
    //section.find('.video-section__cover-background').fadeOut(200);
    //section.find('.cover_image').fadeOut(200);
    //section.find('.player--wrapper').css({opacity: 1});
    section.find('.player--wrapper').removeClass('player--wrapper_loading');
    firstBgPlay = false;
  }
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function zoomOnProduct() {

var productMediaContainer = $('.product__content .product__form-container .product__media-container');
productMediaContainer.on('mousemove touchmove', function (e) {
    var parent = $(this)[0];
    var pos = getPositionByParent(e);
    var img = $(this).find('.product__media-preview-image');

    var parentWidth = $(this).width();
    var parentHeight = $(this).height();
    var fixedLeft = (img.width() - parentWidth);
    var fixedTop = (img.height() - parentHeight);

    var left = -((pos.x / parentWidth) - 0.5) * fixedLeft;
    var top = -((pos.y / parentHeight) - 0.5) * fixedTop;
    console.log(top);

    img.css({
        'left' : left + 'px',
        'top' : top + 'px'
    });

    function getPositionByParent(e) {
        var a, x = 0, y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = parent.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
    }

});

productMediaContainer.on('mouseleave', function() {
    var img = $(this).find('.product__media-preview-image');
    img.css({
        'left' : 0,
        'top' : 0
    });
});

}

$("li.site-nav--has-dropdown").on('mouseenter mouseleave', function(e) {
  if (e.type === 'mouseenter'){
      $(this).children("ul").animate({'display': 'block'}, 100);
	  
  } 
   else 
      $(this).children("ul").animate({'display': 'none'}, 100);   
});

$(".pause").css("display","block");

/*$( "nav button#open_nav" ).trigger( "click" );*/


